import ApiService from '@/common/api.service'

export default {
    getAdminUpdateNotice (id) {
        return new Promise((resolve, reject) => {
                ApiService.query('/update-notice-admin/' + id).then(response => {
                 resolve(response)
            })
        })
    },
    getMemberUpdateNotice (id) {
        return new Promise((resolve, reject) => {
                ApiService.query('/update-notice-member/' + id).then(response => {
                resolve(response)
            })
        })
    },
    getUpdateNoticeDivisionInfo (id, role) {
        if (role === 'admin') {
            return new Promise((resolve, reject) => {
                    ApiService.query('/update-notice-admin/division-info/' + id).then(response => {
                    resolve(response)
                })
            })
        } else {
            return new Promise((resolve, reject) => {
                    ApiService.query('/update-notice-member/division-info/' + id).then(response => {
                    resolve(response)
                })
            })
        }
    },
    getAdminUpdateNoticeChatInfo (id) {
        return new Promise((resolve, reject) => {
                ApiService.query('/update-notice-admin/chat/' + id).then(response => {
                resolve(response)
            })
        })
    }
}
